@if (error(); as err) {
  <p class="ks-out__error" role="alert">{{ err }}</p>
}

@if (business().length) {
  <mat-card appearance="outlined" class="ks-out" data-testid="outstanding-business">
    <mat-card-content>
      <h2 class="ks-out__title">To keep your application moving, we need:</h2>
      <ul class="ks-out__list">
        @for (item of business(); track item.key) {
          <li class="ks-out__item" [attr.data-testid]="'outstanding-' + item.key">
            <p class="ks-out__text">{{ item.text }}</p>
            @if (item.asked_at) {
              <p class="ks-out__asked">Asked for {{ item.asked_at | date: 'd MMM y' }}</p>
            }

            <div class="ks-out__act">
              @switch (item.act) {
                @case ('UPLOAD_BANK_STATEMENT') {
                  <label class="ks-out__file" mat-stroked-button>
                    <input
                      type="file"
                      multiple
                      [accept]="accept"
                      [disabled]="busyKey() !== null"
                      (change)="upload(item, $event)"
                    />
                    {{ busyKey() === item.key ? 'Uploading…' : 'Upload bank statements' }}
                  </label>
                }
                @case ('ACCOUNT_CONFIRMATION') {
                  @if (!namingAccounts()) {
                    <button
                      mat-stroked-button
                      type="button"
                      [disabled]="busyKey() !== null"
                      (click)="confirmAll(item)"
                    >
                      Yes — every account is uploaded
                    </button>
                    <button mat-button type="button" (click)="namingAccounts.set(true)">
                      No — some are not uploaded
                    </button>
                  } @else {
                    <div class="ks-out__rows">
                      @for (row of accountRows(); track $index; let i = $index) {
                        <div class="ks-out__row">
                          <mat-form-field appearance="outline">
                            <mat-label>Bank</mat-label>
                            <input
                              matInput
                              [value]="row.bank_name"
                              (input)="updateRow(i, 'bank_name', $any($event.target).value)"
                            />
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Last four digits (if known)</mat-label>
                            <input
                              matInput
                              maxlength="4"
                              [value]="row.last_four"
                              (input)="updateRow(i, 'last_four', $any($event.target).value)"
                            />
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Why aren't they uploaded?</mat-label>
                            <input
                              matInput
                              [value]="row.reason"
                              (input)="updateRow(i, 'reason', $any($event.target).value)"
                            />
                          </mat-form-field>
                        </div>
                      }
                      <button mat-button type="button" (click)="addRow()">
                        Add another account
                      </button>
                      <button
                        mat-stroked-button
                        type="button"
                        [disabled]="!rowsReady() || busyKey() !== null"
                        (click)="nameAccounts(item)"
                      >
                        Save
                      </button>
                    </div>
                  }
                }
                @case ('CONSENT') {
                  <p class="ks-out__note">
                    CapX uses AI providers, which may be outside South Africa and which CapX will ensure comply with POPIA, to check the documents submitted for a business and produce an advisory assessment for the CapX team. A person always makes the final decision. One consent, given for the business, covers every funding application made for it until the consent is withdrawn.
                  </p>
                  <button
                    mat-stroked-button
                    type="button"
                    [disabled]="busyKey() !== null"
                    (click)="giveConsent(item)"
                  >
                    Yes, the business consents
                  </button>
                }
                @case ('TAX_PIN') {
                  <ng-container *ngTemplateOutlet="pinBox" />
                }
              }
            </div>
          </li>
        }
      </ul>
    </mat-card-content>
  </mat-card>
}

<!-- DOC-83 §2 (FLOW-352): every PIN sent, who and when — never the PIN. -->
@if (taxPins().length) {
  <mat-card appearance="outlined" class="ks-out" data-testid="tax-pins">
    <mat-card-content>
      <h2 class="ks-out__title">Your SARS Tax Compliance Status PIN</h2>
      <ul class="ks-out__list">
        @for (p of taxPins(); track p.short_id) {
          <li class="ks-out__item ks-out__item--capx">
            <p class="ks-out__text">
              PIN sent by {{ p.given_by_name
              }}{{ p.for_the_business ? ' for the business' : '' }} on
              {{ p.given_at | date: 'd MMM y' }}
            </p>
          </li>
        }
      </ul>
      @if (taxPinOpen() && !pinOwed()) {
        <div class="ks-out__act">
          @if (newPin()) {
            <ng-container *ngTemplateOutlet="pinBox" />
          } @else {
            <button mat-button type="button" (click)="newPin.set(true)">Send a new PIN</button>
          }
        </div>
      }
    </mat-card-content>
  </mat-card>
}

<!-- One box and *Send PIN*. Only an empty box is refused: whether the PIN is
     valid is CapX's check, by a person (DOC-83 §2). -->
<ng-template #pinBox>
  <p class="ks-out__note">
    You can get it on SARS eFiling, under Tax Compliance Status. We use it to check the business's
    tax compliance with SARS.
  </p>
  <mat-form-field appearance="outline">
    <mat-label>Tax Compliance Status PIN</mat-label>
    <input
      matInput
      autocomplete="off"
      maxlength="64"
      [value]="pin()"
      (input)="pin.set($any($event.target).value)"
    />
  </mat-form-field>
  <button
    mat-stroked-button
    type="button"
    [disabled]="!pin().trim() || busyKey() !== null"
    (click)="sendPin()"
  >
    Send PIN
  </button>
</ng-template>

@if (capx().length) {
  <mat-card appearance="outlined" class="ks-out" data-testid="outstanding-capx">
    <mat-card-content>
      <h2 class="ks-out__title">We're working on:</h2>
      <ul class="ks-out__list">
        @for (item of capx(); track item.key) {
          <li class="ks-out__item ks-out__item--capx">
            <p class="ks-out__text">{{ item.text }}</p>
          </li>
        }
      </ul>
    </mat-card-content>
  </mat-card>
}
